"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InstantResultContent = void 0;
var _logger = require("../../logger");
var _Skeleton = require("../Skeleton");
var _InstantResultListRow = require("./InstantResultListRow");
var _NoResultsMessage = require("./NoResultsMessage");
var _jsxRuntime = require("react/jsx-runtime");
const componentName = 'InstantResultContent.tsx';
const InstantResultContent = ({
  display,
  instantResults,
  isInstantResultsLoading,
  searchTerm,
  selectInstantResult
}) => {
  (0, _logger.logDebug)(`Rendering ${componentName} ...`, {
    isInstantResultsLoading,
    instantResults
  });
  if (isInstantResultsLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.InstantResultSkeleton, {});
  }
  if (!instantResults.length) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoResultsMessage.NoResultsMessage, {
      searchTerm: searchTerm
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: instantResults.map(instantResultPickupPoint => {
      const {
        deliveryChannelId
      } = instantResultPickupPoint;
      const instantResultListRowProps = {
        display,
        instantResultPickupPoint,
        searchTerm,
        selectInstantResult
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InstantResultListRow.InstantResultListRow, {
        ...instantResultListRowProps
      }, deliveryChannelId);
    })
  });
};
exports.InstantResultContent = InstantResultContent;